import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Typography from '@mui/material/Typography';

function TrialExpiredModal({ open, message }) {
  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          textAlign: 'center',
          p: 3,
          background: '#fff',
          boxShadow: 8,
        },
      }}
      disableEscapeKeyDown
      onClose={() => {}}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
        <WarningAmberIcon sx={{ fontSize: 48, color: 'warning.main', mb: 1 }} />
        <DialogTitle sx={{ fontWeight: 700, fontSize: '1.5rem', color: 'warning.main', pb: 0 }}>
          Trial Expired
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ color: 'text.primary', mb: 2 }}>
            {message || 'Your free trial period has expired. Please contact support to upgrade your account.'}
          </Typography>
        </DialogContent>
      </Box>
    </Dialog>
  );
}

export default TrialExpiredModal;